import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { SocketContext } from "../../context/SocketContext";
import { MediaContext } from "../../context/MediaContext";
import { Form, Modal } from "react-bootstrap";
import { SButton, SFormControl, SModal, SSecondaryButton } from "../BasicComponents";

export const QuestionModal = (props) => {
  const { t } = useTranslation("", { keyPrefix: "lecture.video_page.modals" });
  const { sendSocketEvent } = useContext(SocketContext);
  const { getVideoTs, slideNumber } = useContext(MediaContext);
  const [questionText, setQuestionText] = useState("");

  const onSubmit = (e) => {
    e.preventDefault();

    if (questionText.length > 0) {
      sendSocketEvent("chat/question", {
        text: questionText,
        videoTs: getVideoTs(),
        slideNumber: slideNumber,
      });

      props.onHide();
    }
  };

  return (
    <SModal {...props}>
      <Modal.Header closeButton>
        <Modal.Title>{t("new_question")}</Modal.Title>
      </Modal.Header>
      <Form onSubmit={onSubmit}>
        <Modal.Body>
          <SFormControl type="text" placeholder={t("question")} onChange={(e) => setQuestionText(e.target.value)} />
        </Modal.Body>
        <Modal.Footer>
          <SSecondaryButton onClick={() => props.onHide()}>{t("close")}</SSecondaryButton>
          <SButton type="submit" disabled={questionText.length === 0}>
            {t("confirm")}
          </SButton>
        </Modal.Footer>
      </Form>
    </SModal>
  );
};

export const BookmarkModal = (props) => {
  const { t } = useTranslation("", { keyPrefix: "lecture.video_page.modals" });
  const { sendSocketEvent } = useContext(SocketContext);
  const { getVideoTs } = useContext(MediaContext);
  const [name, setName] = useState("");

  const onSubmit = (e) => {
    e.preventDefault();

    if (name.length > 0) {
      sendSocketEvent("bookmarks/createBookmark", {
        name,
        videoTs: getVideoTs(),
      });

      props.onHide();
    }
  };

  return (
    <SModal {...props}>
      <Modal.Header closeButton>
        <Modal.Title>{t("new_bookmark")}</Modal.Title>
      </Modal.Header>
      <Form onSubmit={onSubmit}>
        <Modal.Body>
          <SFormControl type="text" placeholder={t("bookmark")} onChange={(e) => setName(e.target.value)} />
        </Modal.Body>
        <Modal.Footer>
          <SSecondaryButton onClick={() => props.onHide()}>{t("close")}</SSecondaryButton>
          <SButton type="submit" disabled={name.length === 0}>
            {t("confirm")}
          </SButton>
        </Modal.Footer>
      </Form>
    </SModal>
  );
};
